import React from 'react';
import { createUseStyles } from 'react-jss';
import RobotIcon from '../icons/RobotIcon';

const useStyles = createUseStyles({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    cursor: 'pointer',
    transition: 'transform .2s ease-in-out, filter .2s ease-in-out',
    transform: ({ selected }) => selected ? 'scale(1.1)' : 'scale(0.95)',
    filter: ({ selected, color }) => selected
      ? `drop-shadow(0 0 5px ${color}) drop-shadow(0 0 12px ${color}66)`
      : 'none',
  },
});

function Robot({ robot }) {
  const classes = useStyles({ selected: robot.selected, color: robot.color });

  return (
    <div className={classes.container}>
      <RobotIcon color={robot.color} />
    </div>
  );
}

export default Robot;
